module.exports = __webpack_public_path__ + "static/visa-logo-small-f3019e2ccf72c58024273de61a0b9070.svg";